<template>
  <div class="left-menu-wrapper" :class="{ 'dark-mode': isDarkMode }">
    <v-icon class="toggle-icon" :icon="isSidebarClosed ? 'mdi-chevron-double-right' : 'mdi-chevron-double-left'
      " :style="toggleIconPosition" @click="toggleDrawer"></v-icon>

    <div :class="['sidebar', { close: isSidebarClosed }]">
      <div class="logo-div" v-if="!isSidebarClosed">
        <div class="img-wrap">
          <v-img aspect-ratio="16/9" :src="currentLogo.logo" alt="logo"></v-img>
        </div>
      </div>

      <div class="logo-div2" v-if="isSidebarClosed">
        <div class="img-wrap2">
          <v-img :src="currentLogo.logoIcon" alt="logo"></v-img>
        </div>
      </div>

      <ul class="nav-list">
        <!-- Loop through navigationItems -->
        <li v-for="(item, index) in filteredNavigationItems" :key="index" @click="toggleSubmenu(index)"
          :class="{ show: item.isVisible }">
          <div v-if="item.children" class="icon-link" :class="{ 
            'active-item-sub': item.title === activeMenu || 
                          (item.children && item.children.some(child => child.route === $route.path)) 
          }">
            <div class="link">
              <img :src="(item.title === activeMenu || 
                         (item.children && item.children.some(child => child.route === $route.path))) 
                        ? item.activeImage 
                        : item.image" />
              <span class="link-name">{{ item.title }}</span>
              <div class="arrow-img arrow">
                <v-img src="../../../assets/Images/LeftMenu/rightarrowblack.png" alt="arrow down"></v-img>
              </div>
            </div>
          </div>
          <ul v-if="item.children" :class="{ show: item.isVisible }" class="sub-menu">
            <li v-for="(childItem, childIndex) in item.children" :key="childIndex">
              <router-link v-if="childItem.route" :to="typeof childItem.route === 'string' ? childItem.route : childItem.route" class="sub-link">
                <img :src="$route.fullPath === childItem.route ? childItem.activeImage : childItem.image" />
                <span :class="{ 'active-text-child': $route.fullPath === childItem.route }">
                  {{ childItem.title }}
                </span>
              </router-link>
              <span v-else class="sub-link">
                <img :src="childItem.image" />
                <span :class="{ 'active-text': $route.path === childItem.route }">{{ childItem.title }}</span>
              </span>
            </li>
          </ul>
          <div class="icon-link" v-else :class="{ 'active-item': item.title === activeMenu }">
            <router-link v-if="item.route" :to="item.route" class="link">
              <img :src="item.title === activeMenu ? item.activeImage : item.image
                " />
              <span class="link-name" :class="{ 'active-text': item.title === activeMenu }">{{ item.title }}</span>
            </router-link>
            <div v-else class="link" @click="handleClick(item)">
              <img :src="item.image" />
              <div class="eda-content">
                <span class="link-name">{{ item.title }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="left-footer" v-if="!isSidebarClosed">
        <div class="footer-img">
          <v-img 
            aspect-ratio="16/9" 
            :src="selectedTenant === 'ExxonMobil' ? currentLogo.exxonLogo : selectedTenant === 'adnoc_demo' ? currentLogo.adnocLogo : currentLogo.tenantName" 
            alt="logo"
            :style="selectedTenant === 'adnoc_demo' ? { width: '30%', height: '30%', margin: '0 auto' } : {}"
          ></v-img>
        </div>
        
        <!-- <span>{{
          getSelectedTenant ? getSelectedTenant.name : selectedTenant
        }}</span> -->
      </div>
      <div class="logo-div2 " v-else>
        <div class="img-wrap2">
          <v-img :src="selectedTenant === 'ExxonMobil' ? currentLogo.exxonLogoIcon : selectedTenant === 'adnoc_demo' ? currentLogo.adnocLogoIcon : currentLogo.smallLogo" alt="logo"></v-img>
        </div>
        <!-- <span>{{
          getSelectedTenant ? getSelectedTenant.name : selectedTenant
        }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../../eventBus.js";
import { getTenantPrefix } from "../../../utils/tenant.js";

export default {
  name: "LeftMenu",
  data() {
    return {
      isVisible: false,
      isSidebarClosed: true,
      screenWidth: 0,
      drawer: true,
      rail: false,
      miniVariant: false,
      selectedTenant: localStorage.getItem("tenantName"),
      activeMenu: '',
      openSubmenu: null,
      logo: {
        logo: require("../../../assets/Images/LeftMenu/logo.png"),
        logoDark: require("../../../assets/Images/LeftMenu/logo-dark.png"),
        logoIcon: require("../../../assets/Images/LeftMenu/logoicon.png"),
        logoIconDark: require("../../../assets/Images/LeftMenu/logoicon-dark.png"),
        tenantName: require("../../../assets/Svg/LeftMenu/logo-full.svg"),
        tenantNameDark: require("../../../assets/Svg/LeftMenu/logo-full-dark.svg"),
        clientLogo: require("../../../assets/Images/LeftMenu/Client Logo.png"),
        exxonLogo: require("../../../assets/Svg/LeftMenu/exxonLogo.svg"),
        exxonLogoIcon: require("../../../assets/Svg/LeftMenu/exxonIcon.svg"),
        smallLogo: require("../../../assets/Images/LeftMenu/tenant-name.png"),
        adnocLogo: require("../../../assets/Svg/LeftMenu/adnocExpand.svg"),
        adnocLogoIcon: require("../../../assets/Svg/LeftMenu/adnocCollapsed.svg"),
      },
      navigationItems: [
      {
          title: "Data Management",
          route: `/${this.tenantId}/data-management`,
          image: require("../../../assets/Svg/LeftMenu/data-management.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        },
        {
          title: "PVT Data Visualization",
          route: `/${this.tenantId}/assets`,
          image: require("../../../assets/Svg/LeftMenu/pvt.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/pvt-active.svg"),
        },
        
        {
          title: "QA/QC",
          route: `/${this.tenantId}/qaqc`,
          image: require("../../../assets/Svg/LeftMenu/QA-QC.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/QA-QC-active.svg"),
        },
        // {
        //   title: "data QA-QC",
        //   route: "",
        //   image: require("../../../assets/Svg/LeftMenu/data-QA-QC_black.svg"),
        // },
        {
          title: "Studio",
          route: `/${this.tenantId}/Fluidsdata-studio`,
          image: require("../../../assets/Svg/LeftMenu/studio.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        },
        // {
        //   title: "visualization & dashboards",
        //   route: "/Visualization-&-Dashboards",
        //   image: require("../../../assets/Svg/LeftMenu/dashboard_black.svg"),
        //   activeImage: require("../../../assets/Svg/LeftMenu/dashboard_white.svg"),
        // },
        {
          title: "Dashboards",
          route: `/${this.tenantId}/Dashboards`,
          image: require("../../../assets/Svg/LeftMenu/dashboard.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        },
        {
          title: "Agentic Dashboard",
          route: `/${this.tenantId}/agentic-dashboard`,
          image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
        },
        {
          title: "Exploratory Data Analysis",
          image: require("../../../assets/Svg/LeftMenu/eda.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/eda-active.svg"),
          isVisible: false,
          children: [
            {
              title: "Inventory Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/inventory-analysis`,
              image: require("../../../assets/Svg/LeftMenu/inventory.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
            },
            {
              title: "2D Histogram/KDE Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/twodhistogram-kde`,
              image: require("../../../assets/Svg/LeftMenu/twod.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/twod-active.svg"),
            },
            {
              title: "Statistical Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/statistical-analysis`,
              image: require("../../../assets/Svg/LeftMenu/statistical.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
            },
            {
              title: "Correlation Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/correlation-analysis`,
              image: require("../../../assets/Svg/LeftMenu/correlation.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
            },
            {
              title: "Heatmap Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/heatmap-analysis`,
              image: require("../../../assets/Svg/LeftMenu/treemap.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
            },
            {
              title: "Bubble Plot Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/bubble-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/bubble.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
            },
            {
              title: "3D Plot Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/3d-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/threed.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/threed-active.svg"),
            },
            {
              title: "Composition Gradient Analysis",
              route: `/${this.tenantId}/exploratory-data-analysis/composition-gradient-analysis`,
              image: require("../../../assets/Svg/LeftMenu/depth.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/depth-active.svg"),
            },
           
          ],
          
        },
        {
          title: "Fluids Intelligence",
          image: require("../../../assets/Images/LeftMenu/fdpal.svg"),
          activeImage: require("../../../assets/Images/LeftMenu/fdpal-active.svg"),
          isVisible: false,
          children: [
            {
              title: "PVT Property Prediction",
              route: `/${this.tenantId}/pvt-prediction`,
              image: require("../../../assets/Svg/LeftMenu/pvt-prediction.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/pvt-prediction-active.svg"),
            },
            {
              title: "Agentic AI",
              route: `/${this.tenantId}/fluidsIntelligence`,
              image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
            }
          ]
        },
      //   {
      //   title: "Security",
      //   image: require("../../../assets/Svg/LeftMenu/security-icon.svg"),
      //   activeImage: require("../../../assets/Svg/LeftMenu/security-icon.svg"),
      //   children: [
      //     {
      //       title: "User Management",
      //       image: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       activeImage: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       route:
      //         `/${this.tenantId}/users`,
      //     },
      //     {
      //       title: "Role Management",
      //       image: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       activeImage: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       route:
      //         `/${this.tenantId}/roles`,
      //     },
      //   ],
      // },
        // {
        //   title: "Property Predictions",
        //   image: require("../../../assets/Svg/LeftMenu/property_prediction_black.svg"),
        //   activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //   isVisible: false,
        //   children: [
        //     {
        //       title: "AI / ML Modeling",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //       route: "/ai-ml-modelling",
        //     },
        //     {
        //       title: "Advanced QA-QC",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //     },
        //     {
        //       title: "Dimensionality Reduction",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //     },
        //     {
        //       title: "Clustering",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //     },
        //     {
        //       title: "Supervised ML Model",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //     },
        //     {
        //       title: "Fluidsdata AI Model",
        //       image: require("../../../assets/Images/LeftMenu/EDA black.png"),
        //       activeImage: require("../../../assets/Images/LeftMenu/EDA white.png"),
        //       route:
        //         "/ai-ml-modelling/define-inputs/upload-reports/Fluidsdata-ai-model",
        //     },
        //   ],
        // },
      ],
    }
  },
  props: {
    menu: {
      type: Boolean,
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(newRoute) {
        // Update navigation items when route changes
        this.updateNavigationItems();
        this.handleRouteChange(newRoute.path);
        this.selectedTenant = localStorage.getItem("tenantName")
        // Keep EDA menu open if we're on an EDA route
        if (newRoute.path.includes('exploratory-data-analysis')) {
          const edaIndex = this.navigationItems.findIndex(item => item.title === "Exploratory Data Analysis");
          if (edaIndex !== -1) {
            this.navigationItems[edaIndex].isVisible = true;
            this.openSubmenu = edaIndex;
          }
        }
        // Keep Fluids Intelligence menu open if we're on a Fluids Intelligence route
        if (newRoute.path.includes('pvt-prediction') || newRoute.path.includes('fluidsIntelligence')) {
          const fluidsIntelligenceIndex = this.navigationItems.findIndex(item => item.title === "Fluids Intelligence");
          if (fluidsIntelligenceIndex !== -1) {
            this.navigationItems[fluidsIntelligenceIndex].isVisible = true;
            this.openSubmenu = fluidsIntelligenceIndex;
          }
        }
      }
    },
    "$route.path"(newPath) {
      this.handleRouteChange(newPath);
      let activeItem = null;
      activeItem = this.navigationItems.find((item) => newPath === item.route);

      // If no main item matches, check subitems
      if (!activeItem) {
        this.navigationItems.forEach((item) => {
          if (item.children) {
          const  activeSubItem = item.children.find(
              (subItem) => newPath === subItem.route
            );
            if (activeSubItem) {
              activeItem = item;
              // Special case: show "PVT Property Prediction" instead of parent "Fluids Intelligence"
              if (activeSubItem.title === "PVT Property Prediction") {
                localStorage.setItem("activeMenu", activeSubItem.title);
                localStorage.setItem("lastActiveMenu", activeSubItem.title);
                this.activeMenu = activeSubItem.title;
              } else {
                localStorage.setItem("activeMenu", item.title); // Store parent item title instead of subitem
                localStorage.setItem("lastActiveMenu", item.title);
                this.activeMenu = item.title;
              }
            }
          }
        });
      } else {
        const currentActiveMenu = this.activeMenu;
        // Save both to localStorage
        localStorage.setItem("lastActiveMenu", currentActiveMenu);
        localStorage.setItem("activeMenu", activeItem.title); // Store main item title
      }
    },
  },
  computed: {
    ...mapGetters("tenantId", ["getSelectedTenant"]),
    ...mapGetters("darkMode", ["isDarkMode"]),
    toggleIconPosition() {
      return this.drawer ? "right: -12px;" : "left: 52px;";
    },
    tenantId() {
      // Only get tenantId from route or getTenantPrefix
      return this.$route.path.split("/")[1] || getTenantPrefix();
    },
    // Get appropriate logo based on dark mode
    currentLogo() {
      if (this.isDarkMode) {
        return {
          logo: this.logo.logoDark,
          logoIcon: this.logo.logoIconDark,
          tenantName: this.logo.tenantNameDark,
          clientLogo: this.logo.clientLogo,
          exxonLogo: this.logo.exxonLogo,
          exxonLogoIcon: this.logo.exxonLogoIcon,
          smallLogo: this.logo.smallLogo,
          adnocLogo: this.logo.adnocLogo,
          adnocLogoIcon: this.logo.adnocLogoIcon,
        };
      }
      return this.logo;
    },
    // Get appropriate navigation icons based on dark mode
    currentNavigationItems() {
      return this.navigationItems.map(item => {
        const newItem = { ...item };
        
        // Handle main item icons
        if (item.image && item.activeImage) {
          newItem.image = this.getDarkModeIcon(item.image, item.title);
          newItem.activeImage = this.getDarkModeIcon(item.activeImage, item.title);
        }
        
        // Handle child item icons
        if (item.children) {
          newItem.children = item.children.map(child => ({
            ...child,
            image: this.getDarkModeIcon(child.image, child.title),
            activeImage: this.getDarkModeIcon(child.activeImage, child.title)
          }));
        }
        
        return newItem;
      });
    },
    filteredNavigationItems() {
    const currentTenant = this.selectedTenant || localStorage.getItem("tenantName");
    return this.currentNavigationItems
      .map((item) => {
        if (item.children) {
          // Filter child routes based on permissions and tenant restrictions
          const filteredChildren = item.children.filter((child) => {
            // Check permission first
            const hasPermission = this.$store.getters["tenantId/hasPermission"](this.getPermissionKey(child.title));
            if (!hasPermission) return false;
            
            // PVT Property Prediction is only available for Fluidsdata tenant
            if (child.title === "PVT Property Prediction" && currentTenant !== "Fluidsdata") {
              return false;
            }
            
            return true;
          });
          
          // Only include parent if it has visible children
          if (filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
        } else {
          // Filter main menu items based on permissions
          if (this.$store.getters["tenantId/hasPermission"](this.getPermissionKey(item.title))) {
            return item;
          }
        }
        return null;
      })
      .filter(Boolean); // Remove null values
  }
  },
  methods: {
    // Get appropriate icon based on dark mode and icon type
    getDarkModeIcon(iconPath, title) {
      if (!this.isDarkMode) return iconPath;
      
      // Map of icon names to their dark mode equivalents
      const darkModeIconMap = {
        // Main navigation icons
        'pvt.svg': require("../../../assets/Svg/LeftMenu/pvt.svg"), // Use same for now, can be updated later
        'pvt-active.svg': require("../../../assets/Svg/LeftMenu/pvt-active.svg"),
        'data-management.svg': require("../../../assets/Svg/LeftMenu/data-management.svg"),
        'data-management-active.svg': require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        'studio.svg': require("../../../assets/Svg/LeftMenu/studio.svg"),
        'studio-active.svg': require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        'dashboard.svg': require("../../../assets/Svg/LeftMenu/dashboard.svg"),
        'dashboard-active.svg': require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        'eda.svg': require("../../../assets/Svg/LeftMenu/eda.svg"),
        'eda-active.svg': require("../../../assets/Svg/LeftMenu/eda-active.svg"),
        
        // Sub-menu icons
        'inventory.svg': require("../../../assets/Svg/LeftMenu/inventory.svg"),
        'inventory-active.svg': require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
        'twod.svg': require("../../../assets/Svg/LeftMenu/twod.svg"),
        'twod-active.svg': require("../../../assets/Svg/LeftMenu/twod-active.svg"),
        'statistical.svg': require("../../../assets/Svg/LeftMenu/statistical.svg"),
        'statistical-active.svg': require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
        'correlation.svg': require("../../../assets/Svg/LeftMenu/correlation.svg"),
        'correlation-active.svg': require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
        'treemap.svg': require("../../../assets/Svg/LeftMenu/treemap.svg"),
        'treemap-active.svg': require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
        'bubble.svg': require("../../../assets/Svg/LeftMenu/bubble.svg"),
        'bubble-active.svg': require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
        'threed.svg': require("../../../assets/Svg/LeftMenu/threed.svg"),
        'threed-active.svg': require("../../../assets/Svg/LeftMenu/threed-active.svg"),
        'depth.svg': require("../../../assets/Svg/LeftMenu/depth.svg"),
        'depth-active.svg': require("../../../assets/Svg/LeftMenu/depth-active.svg"),
      };
      
      // Extract filename from path
      const fileName = iconPath.split('/').pop();
      
      // Return dark mode icon if available, otherwise return original
      return darkModeIconMap[fileName] || iconPath;
    },
    
    getPermissionKey(title) {
    const permissionMap = {
      "PVT Data Visualization": "ReadPVTData",
      "Data Management": "ViewDataManagement",
      "QA/QC": "ViewDataManagement",
      "Studio": "ViewStudio",
      "Dashboards": "ViewDashboards",
      "Agentic Dashboard": "ViewDashboards",
      "Exploratory Data Analysis": "ViewEDA",
      "Inventory Analysis": "ViewEDA",
      "Correlation Analysis": "ViewEDA",
      "Statistical Analysis": "ViewEDA",
      "Composition Gradient Analysis": "ViewEDA",
      "2D Histogram/KDE Analysis": "ViewEDA",
      "Heatmap Analysis": "ViewEDA",
      "Bubble Plot Analysis": "ViewEDA",
      "3D Plot Analysis": "ViewEDA",
      "Security": "ManageRoles",
      "User Management": "ManageUsers",
      "Role Management": "ManageRoles",
      "Fluids Intelligence": "ViewDataManagement",
      "PVT Property Prediction": "ViewDataManagement",
      "Agentic AI": "ViewDataManagement"
    };

    return permissionMap[title] || null;
  },
    updateNavigationItems() {
      // Get current tenantId from route
      const currentTenantId = this.tenantId;
      this.navigationItems = [
        {
          title: "Data Management",
          route: `/${currentTenantId}/data-management`,
          image: require("../../../assets/Svg/LeftMenu/data-management.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/data-management-active.svg"),
        },
        {
          title: "PVT Data Visualization",
          route: `/${currentTenantId}/assets`,
          image: require("../../../assets/Svg/LeftMenu/pvt.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/pvt-active.svg"),
        },
        {
          title: "QA/QC",
          route: `/${currentTenantId}/qaqc`,
          image: require("../../../assets/Svg/LeftMenu/QA-QC.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/QA-QC-active.svg"),
        },
        {
          title: "Studio",
          route: `/${currentTenantId}/Fluidsdata-studio`,
          image: require("../../../assets/Svg/LeftMenu/studio.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/studio-active.svg"),
        },
        {
          title: "Dashboards",
          route: `/${currentTenantId}/Dashboards`,
          image: require("../../../assets/Svg/LeftMenu/dashboard.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/dashboard-active.svg"),
        },
        {
          title: "Agentic Dashboard",
          route: `/${currentTenantId}/agentic-dashboard`,
          image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
        },
        {
          title: "Exploratory Data Analysis",
          image: require("../../../assets/Svg/LeftMenu/eda.svg"),
          activeImage: require("../../../assets/Svg/LeftMenu/eda-active.svg"),
          isVisible: false,
          children: [
            {
              title: "Inventory Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/inventory-analysis`,
              image: require("../../../assets/Svg/LeftMenu/inventory.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/inventory-active.svg"),
            },
            {
              title: "2D Histogram/KDE Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/twodhistogram-kde`,
              image: require("../../../assets/Svg/LeftMenu/twod.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/twod-active.svg"),
            },
            {
              title: "Statistical Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/statistical-analysis`,
              image: require("../../../assets/Svg/LeftMenu/statistical.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/statistical-active.svg"),
            },
            {
              title: "Correlation Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/correlation-analysis`,
              image: require("../../../assets/Svg/LeftMenu/correlation.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/correlation-active.svg"),
            },
            {
              title: "Heatmap Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/heatmap-analysis`,
              image: require("../../../assets/Svg/LeftMenu/treemap.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/treemap-active.svg"),
            },
            {
              title: "Bubble Plot Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/bubble-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/bubble.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/bubble-active.svg"),
            },
            {
              title: "3D Plot Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/3d-plot-analysis`,
              image: require("../../../assets/Svg/LeftMenu/threed.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/threed-active.svg"),
            },
            {
              title: "Composition Gradient Analysis",
              route: `/${currentTenantId}/exploratory-data-analysis/composition-gradient-analysis`,
              image: require("../../../assets/Svg/LeftMenu/depth.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/depth-active.svg"),
            },
          ],
        },
        {
          title: "Fluids Intelligence",
          image: require("../../../assets/Images/LeftMenu/fdpal.svg"),
          activeImage: require("../../../assets/Images/LeftMenu/fdpal-active.svg"),
          isVisible: false,
          children: [
            {
              title: "PVT Property Prediction",
              route: `/${currentTenantId}/pvt-prediction`,
              image: require("../../../assets/Svg/LeftMenu/pvt-prediction.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/pvt-prediction-active.svg"),
            },
            {
              title: "Agentic AI",
              route: `/${this.tenantId}/fluidsIntelligence`,
              image: require("../../../assets/Svg/LeftMenu/agentic-ai.svg"),
              activeImage: require("../../../assets/Svg/LeftMenu/agentic-ai-active.svg"),
            }
          ]
        },
      //   {
      //   title: "Security",
      //   image: require("../../../assets/Svg/LeftMenu/security-icon.svg"),
      //   activeImage: require("../../../assets/Svg/LeftMenu/security-icon.svg"),
      //   children: [
      //     {
      //       title: "User Management",
      //       image: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       activeImage: require("../../../assets/Svg/LeftMenu/bullet-active.svg"),
      //       route:
      //       `/${this.tenantId}/users`,
      //     },
      //     {
      //       title: "Role Management",
      //       image: require("../../../assets/Svg/LeftMenu/bullet-black.svg"),
      //       activeImage: require("../../../assets/Svg/LeftMenu/bullet-active.svg"),
      //       route:
      //         `/${this.tenantId}/roles`,
      //     },
      //   ],
      // },
      ];
    },
    handleClick(item) {
      if (item.title === "Exploratory Data Analysis") {
        const index = this.navigationItems.findIndex(navItem => navItem.title === "Exploratory Data Analysis");
        if (index !== -1) {
          this.toggleSubmenu(index);
        }
        return;
      }
      if (item.title === "Fluids Intelligence") {
        const index = this.navigationItems.findIndex(navItem => navItem.title === "Fluids Intelligence");
        if (index !== -1) {
          this.toggleSubmenu(index);
        }
        return;
      }
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
      this.$emit("drawerStateChanged", this.drawer);
      this.isSidebarClosed = !this.isSidebarClosed;
      this.$emit("drawerHold", this.drawer);

      // Emit via eventBus for components that need to listen globally
      eventBus.emit("mainSidebarStateChanged", this.drawer);

      // When opening the sidebar, always open the EDA submenu
      if (!this.isSidebarClosed) {
        // Find the EDA menu item
        const edaIndex = this.navigationItems.findIndex(item => item.title === "Exploratory Data Analysis");
        
        if (edaIndex !== -1) {
          // Force open the EDA submenu using direct property assignment
          this.navigationItems[edaIndex].isVisible = true;
          
          // Make sure Vue detects the change
          this.navigationItems = [...this.navigationItems];
          this.openSubmenu = edaIndex;
        }
      }

      // Emit event to trigger chart resize
      eventBus.emit("resizeChart");
    },
    toggleSubmenu(index) {
      const item = this.navigationItems[index];
      
      // Toggle the clicked item's visibility
      item.isVisible = !item.isVisible;
      
      // Update openSubmenu state if opening a submenu
      if (item.isVisible) {
        this.openSubmenu = index;
      } else if (this.openSubmenu === index) {
        this.openSubmenu = null;
      }
      
      // Don't close other submenus - this is the key change
      // We're removing the code that would close other submenus
      
      // Make sure Vue detects the change
      this.navigationItems = [...this.navigationItems];
    },
    checkScreenWidth() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 768) {
        this.drawer = false;
        this.isSidebarClosed = true;
      } else if (this.screenWidth > 768) {
        if (this.menu) {
          this.drawer = true;
          this.isSidebarClosed = false;
        } else {
          this.drawer = true;
          this.isSidebarClosed = false;
        }
        this.toggleDrawer()
      }
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.toggleDrawer();
      }
    },
    handleRouteChange(newPath) {
      // Update navigation items with current tenantId
      this.updateNavigationItems();
      
      let activeItem = null;
      let activeSubItem = null;
      
      // First check main items
      activeItem = this.navigationItems.find((item) => {
        if (newPath === item.route) return true;
        // Special handling for agentic-dashboard sub-routes
        if (item.title === "Agentic Dashboard" && item.route && newPath.startsWith(item.route)) {
          return true;
        }
        return false;
      });

      // If no main item matches, check subitems
      if (!activeItem) {
        this.navigationItems.forEach((item, index) => {
          if (item.children) {
            const foundSubItem = item.children.find(
              (subItem) => newPath === subItem.route || 
                          (newPath.includes('exploratory-data-analysis') && subItem.route.includes(newPath.split('?')[0]))
            );
            if (foundSubItem) {
              activeItem = item;
              activeSubItem = foundSubItem;
              // Keep the submenu open when a child is selected
              item.isVisible = true;
              this.openSubmenu = index;
              this.activeMenu = item.title;
              localStorage.setItem("activeMenu", item.title);
              localStorage.setItem("lastActiveMenu", item.title);
            }
          }
        });
        
        // Check if it's a QA/QC sub-route
        if (newPath.startsWith(`/${this.tenantId}/qaqc/`)) {
          activeItem = this.navigationItems.find(item => item.title === "QA/QC");
          if (activeItem) {
            this.activeMenu = activeItem.title;
            localStorage.setItem("activeMenu", activeItem.title);
            localStorage.setItem("lastActiveMenu", activeItem.title);
          }
        }
        
        // Check if it's PVT Property Prediction route - show child title instead of parent
        if (newPath === `/${this.tenantId}/pvt-prediction` || newPath.startsWith(`/${this.tenantId}/pvt-prediction`)) {
          if (activeSubItem && activeSubItem.title === "PVT Property Prediction") {
            this.activeMenu = activeSubItem.title;
            localStorage.setItem("activeMenu", activeSubItem.title);
            localStorage.setItem("lastActiveMenu", activeSubItem.title);
          }
        }
      } else {
        const currentActiveMenu = this.activeMenu;
        localStorage.setItem("lastActiveMenu", currentActiveMenu);
        localStorage.setItem("activeMenu", activeItem.title);
        this.activeMenu = activeItem.title;
      }

      // Always ensure EDA menu stays open regardless of route
      const edaIndex = this.navigationItems.findIndex(item => item.title === "Exploratory Data Analysis");
      if (edaIndex !== -1) {
        this.navigationItems[edaIndex].isVisible = true;
      }
      
      // Always ensure Fluids Intelligence menu stays open if on a Fluids Intelligence route
        const fluidsIntelligenceIndex = this.navigationItems.findIndex(item => item.title === "Fluids Intelligence");
        if (fluidsIntelligenceIndex !== -1) {
          this.navigationItems[fluidsIntelligenceIndex].isVisible = true;
        }
      
      const activeMenu = localStorage.getItem("activeMenu") || "Data Management";
      const lastActiveMenu = localStorage.getItem("lastActiveMenu");
      const routePath = this.$route.path;
      if ([`/${this.tenantId}/assets`, `/${this.tenantId}/data-management`, `/${this.tenantId}/qaqc`, `/${this.tenantId}/Fluidsdata-studio`, `/${this.tenantId}/Fluidsdata-studio-one`, `/${this.tenantId}/Fluidsdata-studio-two`, `/${this.tenantId}/Dashboards`, `/${this.tenantId}/agentic-dashboard`, `/${this.tenantId}/exploratory-data-analysis`, `/${this.tenantId}/users`, `/${this.tenantId}/fluidsIntelligence`, `/${this.tenantId}/pvt-prediction`, `/${this.tenantId}/roles`].includes(routePath) || routePath.startsWith(`/${this.tenantId}/agentic-dashboard`)) {
        if (routePath === `/${this.tenantId}/exploratory-data-analysis`) {
          this.localStorageMenuTitle = "Exploratory Data Analysis";
        }
        if (routePath === `/${this.tenantId}/qaqc` || routePath.startsWith(`/${this.tenantId}/qaqc/`)) {
          this.localStorageMenuTitle = "QA/QC";
        }
        this.activeMenu = activeMenu;
      } else {
        if (lastActiveMenu === "PVT Data Visualization" && activeMenu === "Data Management") {
          this.localStorageMenuTitle = activeMenu;
        }
        else if (lastActiveMenu === "Data Management" && activeMenu === "PVT Data Visualization") {
          this.localStorageMenuTitle = activeMenu;
        }
        else if (lastActiveMenu === "PVT Data Visualization") {
          this.activeMenu = lastActiveMenu;
        } else if (lastActiveMenu === "Data Management") {
          this.activeMenu = lastActiveMenu;
        }
        else if (lastActiveMenu === "Fluidsdatapal") {
          this.activeMenu = lastActiveMenu;
        }
      }

      // If we found a subitem, make sure its parent menu is visible
      if (activeSubItem && activeItem) {
        activeItem.isVisible = true;
      }
    },
  },
  mounted() {
    this.handleRouteChange(this.$route.path);
    this.checkScreenWidth();
    window.addEventListener("resize", this.checkScreenWidth);
    window.addEventListener("keydown", this.handleKeydown);
    // Always ensure EDA submenu is open
    const edaIndex = this.navigationItems.findIndex(item => item.title === "Exploratory Data Analysis");
    if (edaIndex !== -1) {
      this.navigationItems[edaIndex].isVisible = true;
      this.navigationItems = [...this.navigationItems];
    }
    
    // Always ensure Fluids Intelligence submenu is open if on a Fluids Intelligence route
    const currentPath = this.$route.path;
    if (currentPath.includes('pvt-prediction') || currentPath.includes('fluidsIntelligence')) {
      const fluidsIntelligenceIndex = this.navigationItems.findIndex(item => item.title === "Fluids Intelligence");
      if (fluidsIntelligenceIndex !== -1) {
        this.navigationItems[fluidsIntelligenceIndex].isVisible = true;
        this.navigationItems = [...this.navigationItems];
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenWidth);
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>
